import WatchLaterIcon from '@mui/icons-material/WatchLater';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import ListItemText from '@mui/material/ListItemText';
import { styled as muiStyled } from '@mui/material/styles';
import { CreateCSSProperties } from '@mui/styles';
import styled from 'styled-components';

import ColormapInterface from 'shared-types/colormapinterface';
import { fontSize, fontWeight, getSpacing, lineHeight, letterSpacing } from 'stylesheetB2b';

const LIST_ITEM_SECONDARY_ACTION_RIGHT_FACTOR = 2;

export const textCommonStyle: CreateCSSProperties<object> = {
  letterSpacing: letterSpacing.normal,
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
};

export const StyledListItemText = muiStyled(ListItemText)<{ colors: ColormapInterface, elapsedtime?: boolean; }>(
  ({ colors, elapsedtime }) => ({
    '& .MuiTypography-body1': {
      fontWeight: fontWeight.bold,
      fontSize: getSpacing(3),
      lineHeight: lineHeight.small,
      color: elapsedtime ? 'grey' : colors.waitingListSongArtist,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      ...textCommonStyle,
    },
    '& .MuiTypography-body2': {
      fontSize: fontSize.extraSmall,
      fontWeight: fontWeight.light,
      lineHeight: lineHeight.small,
      color: elapsedtime ? 'grey' : colors.waitingListSongArtist,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      ...textCommonStyle,
    },
  }),
);

export const StyledListItemSecondaryAction = muiStyled(ListItemSecondaryAction)(() => ({
  right: getSpacing(LIST_ITEM_SECONDARY_ACTION_RIGHT_FACTOR),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: 'auto',
}));

export const DragHandleIconContainer = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledElapsedTimeIcon = styled(WatchLaterIcon) <{ colors: ColormapInterface }>`
  color: ${({ colors }) => colors.elapsedTimeICon};
`;
